<template>
  <div>
    <a-card :bordered="false" :title="this.title">
      <div>
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item @click="handleClick" key="BasicFlag">{{$t('message.lzdInboundCreateView.title.basicFlag')}}</a-menu-item>
          <a-menu-item @click="handleClick" key="SellerFlag"> {{$t('message.lzdInboundCreateView.title.sellerFlag')}}</a-menu-item>
          <a-menu-item @click="handleClick" key="SkuFlag">{{$t('message.lzdInboundCreateView.title.skuFlag')}}</a-menu-item>
        </a-menu>
      </div>
    </a-card>
    <br>
    <a-card :bordered="false" id="BasicFlag" :title="$t('message.lzdInboundCreateView.title.basicFlag')">
      <a-form class="ant-advanced-search-form" :form="form">
        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.lzdInboundCreateView.tableColumn.warehouse')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..."
                        v-model="inboundPlanForm.warehouseId" :options="warehouseOptions">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.lzdInboundCreateView.tableColumn.deliverType')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..." v-model="inboundPlanForm.deliverTypeId"
                        v-decorator="['note', { rules: [{ required: true, message: 'Please select deliverType!' }] }]"
                        :options="inboundPlanForm.deliverTypeList">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.lzdInboundCreateView.tableColumn.inboundType')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..."
                        v-decorator="['note2', { rules: [{ required: true, message: 'Please select inventoryType!' }] }]"
                        v-model="inboundPlanForm.inventoryTypeId">
                <a-select-option value="1">Good</a-select-option>
                <a-select-option value="101">Defective</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>

          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.lzdInboundCreateView.tableColumn.estimatedTime')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                @change="onEstimatedChange"
                v-decorator="['note3', { rules: [{ required: true, message: 'Please select Estimated Time!' }] }]"
              />
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>

    </a-card>

    <a-card :bordered="false" id="SellerFlag" :title="$t('message.lzdInboundCreateView.title.sellerFlag')">
      <a-card :bordered="false" id="warehouse" :title="$t('message.lzdInboundCreateView.title.sellerAddress')">
        <a-form class="ant-advanced-search-form" :form="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.title.sellerAddress')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                <a-select placeholder="..."
                          v-model="inboundPlanForm.sellerWareAddressId"
                          :options="inboundPlanForm.sellerWareAddressArray" @change="handleSellerWarehouseChange"
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.sellerDetail')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.address}}
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.sellerCountry')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.country}}
              </a-form-item>
            </a-col>country


          </a-row>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.sellerCity')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.city}}
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.sellerPostcode')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.postCode}}
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>
      </a-card>
      <a-card :bordered="false" id="contact" :title="$t('message.lzdInboundCreateView.tableColumn.contactInfo')">
        <a-form class="ant-advanced-search-form" :form="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.contactPerson')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.contactName}}

              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.tableColumn.contactInfo')"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18, offset: 1}"
              >
                {{this.sellerInformation.mobileNum}}
              </a-form-item>
            </a-col>

          </a-row>
        </a-form>
      </a-card>
    </a-card>
    <br>
    <a-card :bordered="false" id="SkuFlag" :title="$t('message.lzdInboundCreateView.title.skuFlag')">
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row>
        <span style="float: right; margin-top: 2px;">
          <a-button @click="AddSkuClick" type="primary">{{$t('message.lzdInboundCreateView.tableColumn.addBtn')}}</a-button>
        </span>
        </a-row>
        <a-row>
          <a-table bordered :data-source="dataSource" :columns="columns" :loading="loading">
            <template slot="requestedQuantity" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record, 'requestedQuantity', $event)"/>
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm
                v-if="dataSource.length"
                title="Sure to delete?"
                @confirm="() => onDelete(record.key)"
              >
                <a href="javascript:;">{{$t('message.lzdInboundCreateView.tableColumn.deleteBtn')}}</a>
              </a-popconfirm>
            </template>
          </a-table>
        </a-row>
        <a-row>
          <div style="text-align:center">
            <a-button @click="handleSubmitBtnClick" type="primary">{{$t('message.lzdInboundCreateView.tableColumn.submitBtn')}}</a-button>
          </div>
        </a-row>
      </a-form>

    </a-card>

    <!--add sku提示框-->
    <div :key="addSkuWindowKey">
      <a-modal
        :visible="addSkuAlert.visible"
        :width="1000"
        @ok="submitAddSkuClick"
        :closable=true
        :mask="addSkuAlert.showMask"
        :cancelText="$t('message.inboundView.alert.cancel')"
        title="Add Sku"
        @cancel="closeAddSkuAlertMask"
      >
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku')"
                :labelCol="{span: 8}"
              >
                <a-input placeholder="..." style="width: 80%" v-model="sellerSkuFromRequest.fulfilmentSku"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.addSkuView.queryView.platformSku')"
                :labelCol="{span: 8}"
              >
                <a-input placeholder="..." style="width: 80%" v-model="sellerSkuFromRequest.platformSku"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                :label="$t('message.lzdInboundCreateView.addSkuView.queryView.sellerSku')"
                :labelCol="{span: 8}"
              >
                <a-input placeholder="..." style="width: 80%" v-model="sellerSkuFromRequest.sellerSku"/>
              </a-form-item>
            </a-col>

          </a-row>

          <a-row>
            <span style="float: right; margin-top: 2px;">
          <a-button @click="handleSkuSearch" type="primary">{{$t('message.lzdInboundCreateView.addSkuView.searchBtn')}}</a-button>
          <a-button @click="resetSkuBtnClick" style="margin-left: 8px">{{$t('message.lzdInboundCreateView.addSkuView.resetBtn')}}</a-button>
        </span>
          </a-row>
        </a-form>
        <a-table :columns="skuColumns" :rowKey="skuRowKey" :scroll="{ x: 800, y: 800 }" :dataSource="skuDataSource"
                 :pagination="skuPagination" :loading="skuLoading"
                 @change="getSellerSkuTableData"
                 :row-selection="{ selectedRowKeys: selectedSkuRowKeys, onChange: onSkuSelectChange }"
        >
        </a-table>
      </a-modal>
    </div>

  </div>
</template>

<script>
import {InboundApi} from '../../js/InboundApi'
import request from '../../utils/request'

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check"/>
          <a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit"/>
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data () {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange (e) {
      const value = e.target.value
      this.value = value
    },
    check () {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit () {
      this.editable = true
    }
  }
}

export default {
  components: {
    EditableCell
  },
  computed:{
    columns () {
      return [
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.fulfilmentSku'),
          dataIndex: 'cnSkuCode',
          width: '30%'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.platformSku'),
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.scItemName'),
          dataIndex: 'scItemName'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.shelfLife'),
          dataIndex: 'isShelfLifeMgmtName'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.serialNumber'),
          dataIndex: 'isSerialNumberMgmtName'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.goodQuantity'),
          dataIndex: 'goodQuantity'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.quantity'),
          dataIndex: 'replQuantity',
          scopedSlots: {customRender: 'requestedQuantity'}

        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.operate'),
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'}
        }
      ]
    },
    skuColumns () {
      return [
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.fulfilmentSku'),
          dataIndex: 'cnSkuCode',
          width: '30%'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.platformSku'),
          dataIndex: 'platformSkuId'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.sellerSku'),
          dataIndex: 'sellerSkuId'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.goodQuantity'),
          dataIndex: 'goodQuantity'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.scItemName'),
          dataIndex: 'scItemName'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.barcodes'),
          dataIndex: 'barcodes'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.shelfLife'),
          dataIndex: 'isShelfLifeMgmtName'
        },
        {
          title: this.$t('message.lzdInboundCreateView.addSkuView.serialNumber'),
          dataIndex: 'isSerialNumberMgmtName'
        }
      ]
    }
  },
  data () {
    return {
      selectedSkuRecords: [],
      selectedSkuRowKeys: [], // Check here to configure the default column
      skuRowKey: 'platformSkuId',
      rowKey: 'id',
      skuDataSource: this.skuDataSource,
      skuPagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.skuPagination.current = current
          console.log('change current=', this.skuPagination.current)
          this.getSellerSkuTableData()
        }
      },
      sellerSkuFromRequest: {
        fulfilmentSku: '',
        platformSku: '',
        sellerSku: ''
      },
      addSkuAlert: {
        visible: false,
        showMask: true
      },
      addSkuWindowKey: '',
      warehouseOptions: [],
      loading: false,
      skuLoading: true,
      inboundPlanDetailData: {},
      inboundPlanForm: {
        inventoryTypeList: [],
        warehouseId: '',
        ioTypeList: [],
        shopId: '',
        ioTypeId: '',
        inventoryTypeId:'',
        deliverTypeId: '',
        deliverTypeList: [],
        sellerWareAddressId: '',
        sellerWareAddressArray: [],
        estimatedTimeStr: ''
      },
      form: this.$form.createForm(this, {name: 'inbound_plan_detail'}),
      dataSource: this.dataSource,
      count: 2,
      sellerInformation: {
        address: '',
        country: '',
        city: '',
        postCode: '',
        contactName: '',
        mobileNum: ''
      }
    }
  },
  created () {
    const inboundDetailData = this.$route.query.outboundDetailData
    console.log(inboundDetailData)
    this.inboundPlanDetailData = inboundDetailData
    this.initPlanTable()
  },
  mounted () {
  },
  methods: {
    getSellerSkuTableData () {
      this.selectedSkuRowKeys = []
      this.selectedSkuRecords = []
      this.skuLoading = true
      let querySellerSkuParam = {
        cnSkuCode: this.sellerSkuFromRequest.fulfilmentSku,
        platformSkuId: this.sellerSkuFromRequest.platformSku,
        sellerSkuId: this.sellerSkuFromRequest.sellerSku,
        warehouseCode: this.inboundPlanForm.warehouseId,
        sellerId: this.inboundPlanDetailData.shopId,
        pageIndex: this.skuPagination.current,
        inventoryType:this.inboundPlanForm.inventoryTypeId,
        inOrOutBound: true,
        pageSize: 10
      }
      console.log(querySellerSkuParam)
      request({
        url: InboundApi.InboundFromUrl.querySellerSKuUrl,
        method: 'post',
        data: querySellerSkuParam
      }).then(response => {
        console.log(response)
        this.skuDataSource = response.data.model
        const pagination = {...this.pagination}
        pagination.total = response.data.totalCount
        this.skuPagination = pagination
        this.skuLoading = false
      })
    },
    onSkuSelectChange (selectedRowKeys, selectedRecords) {
      this.selectedSkuRowKeys = selectedRowKeys
      this.selectedSkuRecords = selectedRecords
    },
    resetSkuBtnClick () {
      this.sellerSkuFromRequest = {}
    },
    handleSkuSearch () {
      this.getSellerSkuTableData()
    },
    AddSkuClick () {
      this.addSkuWindowKey = Math.random()
      this.addSkuAlert.visible = true
      this.getSellerSkuTableData()
    },
    submitAddSkuClick () {
      if (this.dataSource == null || this.dataSource.length <= 0) {
        this.dataSource = this.selectedSkuRecords
      } else {
        if (this.selectedSkuRecords != null && this.selectedSkuRecords.length > 0) {
          var map = new Map()
          this.dataSource.forEach((d) => {
            map.set(d.cnSkuCode, d)
          })
          console.log("map")
          console.log(map)
          this.selectedSkuRecords.forEach((item) => {
            var temp = map.get(item.cnSkuCode)
            console.log("temp")
            console.log(temp)
            if (temp == null) {
              this.dataSource.push(item)
            }
          })
        }
      }

      this.addSkuAlert.visible = false
      this.loading = false
    },
    closeAddSkuAlertMask () {
      this.addSkuAlert.visible = false
      this.addSkuWindowKey = Math.random()
      this.skuDataSource = []
      this.selectedSkuRecords = []
    },
    handleSellerWarehouseChange (value) {
      request({
        url: InboundApi.InboundFromUrl.sellerWarehouseDetail,
        params: {
          sellerId: this.inboundPlanDetailData.shopId,
          // sellerId: '3829708108',
          // warehouseId: '122362'
          warehouseId: value
        },
        method: 'get'
      }).then(response => {
        console.log(response)
        const info = response.data.model
        const sellerInfo = {
          address: info.address,
          country: info.nationName,
          city: info.cityName,
          postCode: info.postCode,
          contactName: info.contactName,
          mobileNum: info.contactMobileNo
        }
        this.sellerInformation = sellerInfo
      })
    },
    handleClick (e) {
      console.log(e.key)
      var selector = '#' + e.key
      document.querySelector(selector).scrollIntoView(true, {behavior: 'instant', block: 'start'})
    },
    onCellChange (record, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.cnSkuCode === record.cnSkuCode)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
        console.log(this.dataSource)
      }
    },
    onDelete (key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
    },
    initPlanTable () {
      request({
        url: InboundApi.InboundFromUrl.queryWarehouseUrl,
        params: {
          sellerId: this.inboundPlanDetailData.shopId
        },
        method: 'get'
      }).then(response => {
        this.warehouseOptions = response.data.model.map(item => {
          return {label: item.name, value: item.storeCode}
        })
      })

      request({
        url: InboundApi.InboundFromUrl.inboundIoTypeUrl,
        method: 'get'
      }).then(response => {
        this.inboundPlanForm.ioTypeList = response.data.model.map(item => {
          return {label: item.name, value: item.code}
        })
      })
      request({
        url: InboundApi.InboundFromUrl.deliverTypeUrl,
        method: 'get'
      }).then(response => {
        this.inboundPlanForm.deliverTypeList = response.data.model.map(item => {
          return {label: item.name, value: item.code}
        })
      })
      request({
        url: InboundApi.InboundFromUrl.sellerWareHouseUrl,
        method: 'get',
        params: {
          sellerId: this.inboundPlanDetailData.shopId
        }
      }).then(response => {
        this.inboundPlanForm.sellerWareAddressArray = response.data.model.map(item => {
          return {label: item.warehouseName, value: item.warehouseId}
        })
      })
    },
    handleSubmitBtnClick (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.inboundProcess()
        }
      })
    },
    inboundProcess () {
      console.log('outbound')
      console.log(this.inboundPlanDetailData)
      const inboundSubmitParam = {}
      inboundSubmitParam.inventoryType=this.inboundPlanForm.inventoryTypeId
      inboundSubmitParam.deliveryType = this.inboundPlanForm.deliverTypeId
      inboundSubmitParam.estimatedArrivalTime = this.inboundPlanForm.estimatedTimeStr
      inboundSubmitParam.ioType = this.inboundPlanForm.ioTypeId
      inboundSubmitParam.sellerAddress = this.sellerInformation.address
      inboundSubmitParam.sellerCity = this.sellerInformation.city
      inboundSubmitParam.sellerId = this.inboundPlanDetailData.shopId
      inboundSubmitParam.sellerCountry = this.sellerInformation.country
      inboundSubmitParam.sellerContact = this.sellerInformation.contactName
      inboundSubmitParam.sellerMobile = this.sellerInformation.mobileNum
      inboundSubmitParam.sellerPostcode = this.sellerInformation.postCode
      inboundSubmitParam.sellerWarehouseId = this.inboundPlanForm.sellerWareAddressId
      inboundSubmitParam.submit = true
      inboundSubmitParam.warehouseCode = this.inboundPlanForm.warehouseId
      const items = []
      console.log('test')
      // iteminfo
      console.log(inboundSubmitParam)
      console.log(this.dataSource)
      console.log('datasource')
      if (this.dataSource == null || this.dataSource.length <= 0) {
        const h = this.$createElement
        this.$info({
          title: 'Warning',
          content: h('div', {}, [
            h('p', 'Please select the SKUS')
          ]),
          onOk () {
          }
        })
        return
      }
      let checkItemRequestCount = 0
      console.log('3')
      this.dataSource.forEach((item) => {
        if (item.requestedQuantity == null || item.requestedQuantity <= 0 || item.requestedQuantity == '') {
          console.log('4')
          checkItemRequestCount = 100
        } else {
          if (!this.myIsNaN(item.requestedQuantity)) {
            console.log('check')
            console.log(item)
            checkItemRequestCount = 100
          }
        }
      })
      console.log("requestcount"+checkItemRequestCount)
      if (checkItemRequestCount > 0) {
        const h = this.$createElement
        this.$info({
          title: 'Warning',
          content: h('div', {}, [
            h('p', 'Please enter the correct request quantity!')
          ]),
          onOk () {
          }
        })
        return
      }
      console.log('45')
      this.dataSource.forEach((item) => {
        const itemInfo = {}
        itemInfo.barcodes = item.barcodes
        itemInfo.cnSkuCode = item.cnSkuCode
        itemInfo.inOutQuantity = item.requestedQuantity
        itemInfo.platformSkuId = item.platformSkuId
        itemInfo.scItemId = item.scItemId
        itemInfo.serialNumber = item.isSerialNumberMgmtName
        itemInfo.shelfLife = item.isShelfLifeMgmtName
        itemInfo.skuId = item.skuId
        if (item.skuIdList != '') {
          itemInfo.skuIdList = item.skuIdList
        }
        console.log(item)
        items.push(itemInfo)
      })
      inboundSubmitParam.items = items
      console.log(inboundSubmitParam)
      request({
        url: InboundApi.InboundFromUrl.createOutboundUrl,
        method: 'post',
        data: inboundSubmitParam
      }).then(response => {
        console.log(response)
        if (response.data.success) {
          this.$router.push({name: 'outboundList'})
        } else {
          const h = this.$createElement
          this.$info({
            title: 'Warning',
            content: h('div', {}, [
              h('p', response.data.errorMessage)
            ]),
            onOk () {
            }
          })
        }
      })
    },
    myIsNaN (value) {
      var reg = /^[0-9]+.?[0-9]*$/
      if (!reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    onEstimatedChange (value, dateString) {
      console.log('datestring' + dateString)
      this.inboundPlanForm.estimatedTimeStr = dateString
    }
  }
}
</script>
<style>
  .editable-cell {
    position: relative;
  }

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    padding-right: 24px;
  }

  .editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    line-height: 18px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell:hover .editable-cell-icon {
    display: inline-block;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/icp/CreateOutBound.vue